onInteractive(function () {
	var root = document.documentElement;

	// Reveal-on-scroll. Elements start hidden only once we know JS and the
	// observer are available, so a no-JS visit still shows everything.
	var reducedMotion = window.matchMedia
		&& window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	if (!('IntersectionObserver' in window) || reducedMotion) {
		return;
	}

	var selectors = [
		'.hero-text',
		'.hero-media',
		'.usp-card',
		'.welcome-media',
		'.welcome-body',
		'.behandlungen-intro',
		'.treat-item',
		'.soforthilfe-card',
		'.cta-band-inner',
		'.cta-hours',
		'.page-header-inner',
		'.ps > .container',
		'.contact-info',
		'.contact-form-card'
	];

	var targets = Array.prototype.slice.call(
		document.querySelectorAll(selectors.join(','))
	);
	if (!targets.length) {
		return;
	}

	root.classList.add('js-reveal');
	targets.forEach(function (el) {
		el.classList.add('reveal');
	});

	var observer = new IntersectionObserver(function (entries) {
		entries.forEach(function (entry) {
			if (!entry.isIntersecting) {
				return;
			}
			var el = entry.target;

			// Stagger siblings inside the same row so grids cascade in.
			var group = Array.prototype.slice.call(
				el.parentNode ? el.parentNode.children : []
			).filter(function (node) {
				return node.classList && node.classList.contains('reveal');
			});
			var index = Math.max(0, group.indexOf(el));
			el.style.transitionDelay = (index * 90) + 'ms';

			el.classList.add('is-visible');
			observer.unobserve(el);
		});
	}, {
		rootMargin: '0px 0px -8% 0px',
		threshold: 0.12
	});

	targets.forEach(function (el) {
		observer.observe(el);
	});
});
